var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 23,
    viewBox: "0 0 12 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Chevron_Right",
    d: "M0.796518 11.817L10.1415 21.7337C10.5515 22.1679 11.2159 22.1679 11.627 21.7337C12.037 21.2996 12.037 20.5943 11.627 20.1601L3.02324 11.0302L11.6259 1.90034C12.036 1.46616 12.036 0.760924 11.6259 0.325639C11.2159 -0.108546 10.5505 -0.108546 10.1405 0.325639L0.795482 10.2423C0.391731 10.672 0.391731 11.3883 0.796518 11.817Z",
    fill: "#29185E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrLeft);
export default __webpack_public_path__ + "static/media/arr-left.f0060ba59fe375a54e73759cc8d7a3b8.svg";
export { ForwardRef as ReactComponent };